import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_2 = { class: "accordion-header px-3 d-flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", {
  class: "fs-4 fw-bold mb-0 ms-4 py-6 w-50 w-md-100",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#setting_body"
}, "Transaction settings", -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "accordion-icon ms-5",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#setting_body"
}
const _hoisted_6 = { class: "svg-icon svg-icon-2x" }
const _hoisted_7 = {
  id: `setting_body`,
  class: "accordion-collapse collapse",
  "aria-labelledby": "setting_body",
  "data-bs-parent": "#copy_accordion"
}
const _hoisted_8 = { class: "accordion-body" }
const _hoisted_9 = { class: "my-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "max_net_usage_words", -1)
const _hoisted_11 = { class: "my-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "max_cpu_usage_ms", -1)
const _hoisted_13 = { class: "my-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "delay_sec", -1)
const _hoisted_15 = { class: "my-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "context_free_actions", -1)
const _hoisted_17 = { class: "my-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "transaction_extensions", -1)
const _hoisted_19 = { class: "my-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "expiration", -1)
const _hoisted_21 = { class: "my-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "ref_block_num", -1)
const _hoisted_23 = { class: "my-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-1" }, "ref_block_prefix", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr071.svg" })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trx.max_net_usage_words) = $event)),
                class: "form-control form-control-solid",
                name: "proposer"
              }, null, 512), [
                [_vModelText, _ctx.trx.max_net_usage_words]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trx.max_cpu_usage_ms) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.max_cpu_usage_ms]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trx.delay_sec) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.delay_sec]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trx.context_free_actions) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.context_free_actions]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trx.transaction_extensions) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.transaction_extensions]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trx.expiration) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.expiration]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trx.ref_block_num) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.ref_block_num]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trx.ref_block_prefix) = $event)),
                class: "form-control form-control-solid",
                name: "name"
              }, null, 512), [
                [_vModelText, _ctx.trx.ref_block_prefix]
              ])
            ]),
            _hoisted_25
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}